import { Snack } from '@main/snackbar/const';
import { Action } from '@ngrx/store';

export const SET_SNACK = '[Main Layout] Set New Snack';
export const ADD_SNACK = '[Main Layout] Add Snack';
export const TIMEOUT_SNACK = '[Main Layout] Timeout Snack';
export const CLOSE_SNACK = '[Main Layout] Close Snack';
export const REMOVE_SNACK = '[Main Layout] Remove Snack';
export const REMOVE_ALL = '[Main Layout] Remove All';
export const HIDE_SNACKBAR = '[Main Layout] Hide snackbar';

export class SetSnack implements Action {
  readonly type = SET_SNACK;

  constructor(public payload: Snack) {}
}

export class AddSnack implements Action {
  readonly type = ADD_SNACK;

  constructor(public payload: Snack) {}
}

export class CloseSnack implements Action {
  readonly type = CLOSE_SNACK;

  constructor(public payload: Pick<Snack, 'onClose' | 'id'>) {}
}

export class RemoveSnack implements Action {
  readonly type = REMOVE_SNACK;

  constructor(public payload: string) {}
}

export class RemoveAll implements Action {
  readonly type = REMOVE_ALL;

  constructor(public payload: (snack: Snack) => boolean) {}
}

export class HideSnackbar implements Action {
  readonly type = HIDE_SNACKBAR;
}

export type SnackbarActions = SetSnack | AddSnack | CloseSnack | RemoveSnack | RemoveAll | HideSnackbar;
